import axios from 'axios';
import qs from 'qs';
import { Message } from 'element-ui';
import { $Cookies } from '@/utils';
import store from '@/store';
import Vue from 'vue';

const vm = Vue.prototype;
const config = {
  baseURL: '/api',
  timeout: 5000,
  withCredentials: false,
  responseType: 'json',
  xsrfHeaderName: 'X-XSRF-TOKEN',
  xsrfCookieName: 'XSRF-TOKEN',
  maxContentLength: 5000
};
const service = axios.create(config);
const whiteList = ['/token/getToken'];
const stringifyList = [
  '/token/getToken',
  '/token/refreshToken',
  '/user/userInfo/updateUserInfo',
  '/g12eLogin/login/sendMsg',
  '/g12eLogin/login/checkPhone',
  '/user/login/mobileBind',
  '/g12eLogin/login/changePhone',
  '/g12eLogin/register/checkPhoneBind',
  '/g12eLogin/register/register',
  '/g12eLogin/login/mobile',
  '/g12eLogin/login/password',
  '/g12eLogin/register/checkPhone'
];

service.interceptors.request.use(config => {

  const { data, url } = config;
  const authToken = $Cookies.get('authToken');
  if (authToken) {
    config.headers.Authorization = authToken;
    config[ 'refresh_token' ] = false;
  }
  if (whiteList.indexOf(url) === -1) {
    config.headers.Authorization = $Cookies.get('authToken');
  }

  if (stringifyList.indexOf(url) > -1) {
    config.data = qs.stringify(data);
  }

  if (url === '/upload/mfileUpload') {
    config.headers[ 'Content-Type' ] = 'multipart/form-data';
  }

  return config;
}, error => {
  Message.error({
    message: '加载超时'
  });
  return Promise.reject(error);
});

service.interceptors.response.use(response => {
  const errorCode = response.data.errorCode;
  if (errorCode === '-18' || errorCode === '-12') {
    $Cookies.remove('uid');
    $Cookies.remove('username');
    vm.$SignIn();
  }
  return response.data;
}, async error => {
  const response = error.response;
  if (response) {
    const { status } = response;
    if (status === 401) {
      await store.dispatch('auth/refreshToken');
    }
  }
  return Promise.reject(error);
});

export default service;
